import React from "react"
export function LongLayover(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M6.411 6.687L7.837 12h4.203v.001a1 1 0 01.954.999H13v5h-2.003v-4H7.033c-.553 0-.852-.441-1.001-1L4.476 7.204l1.935-.517zM3.457 8.853L5.351 15h4.133v1H4.982a.5.5 0 01-.449-.278l-.03-.075-2.003-6.5.957-.294zM13.494 2.5a4.003 4.003 0 014.006 4c0 2.21-1.794 4-4.006 4a4.003 4.003 0 01-4.006-4c0-2.21 1.794-4 4.006-4zm0 1a3.002 3.002 0 00-3.004 3c0 1.657 1.345 3 3.004 3a3.002 3.002 0 003.005-3c0-1.657-1.346-3-3.005-3zm.507 1V6h.995v1H13V4.5H14zM4.977 3a1.501 1.501 0 11-1.502 1.5c0-.828.672-1.5 1.502-1.5z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__long-layover"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
